import {
  Box,
  Button,
  Card,
  CardContent,
  CardHeader,
  TextField,
  Typography,
} from "@mui/material";
import { useMemo, useState } from "react";
import { useForm } from "react-hook-form";
import calculatorContainerStyle from "./CalculatorContainerStyle";

function TradeResultCalculator() {
  const { register, handleSubmit } = useForm({
    defaultValues: useMemo(() => {
      return {
        amount: localStorage.getItem("amount") || 0,
        riskPercentage: localStorage.getItem("riskPercentage") || 0,
        pip1: localStorage.getItem("pip1") || 0,
        pip2: localStorage.getItem("pip2") || 0,
        lot: localStorage.getItem("lot") || 0,
      };
    }, []),
  });

  const [gainResultAmount, setGainResultAmount] = useState(0);
  const [gainResultPercentage, setGainResultPercentage] = useState(0);

  const onSubmit = (data: any) => {
    try {
      let { amount, lot, pip1, pip2 } = data;

      localStorage.setItem("amount", amount);
      localStorage.setItem("pip1", pip1);
      localStorage.setItem("pip2", pip2);
      localStorage.setItem("lot", lot);

      amount = parseFloat(amount);
      pip1 = parseFloat(pip1);
      pip2 = parseFloat(pip2);

      const gainResultAmount = parseFloat(
        (Math.abs(pip1 - pip2) * lot).toFixed(2)
      );
      const gainResultPercentage = parseFloat(
        ((gainResultAmount / amount) * 100).toFixed(2)
      );

      setGainResultAmount(gainResultAmount);
      setGainResultPercentage(gainResultPercentage);
    } catch {}
  };
  return (
    <form
      onSubmit={handleSubmit(onSubmit)}
      style={{
        maxWidth: "100vw",
        width: "100%",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "space-around",
      }}
    >
      <Box sx={calculatorContainerStyle}>
        <Typography variant="h4" sx={{ mb: 4, textAlign: "center" }}>
          Calculadora de Resultado de indices
        </Typography>
        <TextField
          type="number"
          fullWidth
          label="Capital inicial"
          inputProps={{
            step: "any",
          }}
          {...register("amount")}
        />
        <TextField
          type="number"
          fullWidth
          label="Lotaje"
          inputProps={{
            step: "any",
          }}
          {...register("lot")}
        />
        <TextField
          type="number"
          fullWidth
          label="Precio de entrada"
          inputProps={{
            step: "any",
          }}
          {...register("pip1")}
        />
        <TextField
          type="number"
          fullWidth
          label="Precio salida"
          inputProps={{
            step: "any",
          }}
          {...register("pip2")}
        />

        <Card sx={{ width: "100%" }}>
          <CardHeader title="Resultado" />
          <CardContent>
            <TextField
              type="number"
              fullWidth
              disabled
              label="Resultado de Operacion en monto"
              value={gainResultAmount}
            />
            <TextField
              type="number"
              fullWidth
              disabled
              label="Resultado de Operacion en %"
              sx={{ mt: 1 }}
              value={gainResultPercentage}
            />
          </CardContent>
        </Card>

        <Button fullWidth variant="contained" type="submit">
          Calcular
        </Button>
      </Box>
    </form>
  );
}

export default TradeResultCalculator;
